import React from 'react';
import { ReactComponent as ApostropheSvgTop } from '../assets/img/background-ap-top.svg';
import { ReactComponent as ApostropheSvgBottom } from '../assets/img/background-ap-bottom.svg';
import { ReactComponent as ApostropheSvgLeft } from '../assets/img/background-ap-left.svg';

export const ApostropheBackground = () => {
  const baseStyles = {
    position: 'absolute',
    zIndex: -1,
    height: 'auto',
  };

  const topStyles = {
    ...baseStyles,
    right: 0,
    transform: 'translateX(-70%)',
  };

  const bottomStyles = {
    ...baseStyles,
    bottom: 0,
    transform: 'translateX(150%)',
  };

  const leftStyles = {
    ...baseStyles,
    transform: 'translateY(20%)',
  };

  const classes = 'w-16 md:w-24 lg:w-32';

  return (
    <div className='absolute pin'>
      <ApostropheSvgTop style={topStyles} preserveAspectRatio='none' className={classes}/>
      <ApostropheSvgBottom style={bottomStyles} preserveAspectRatio='none' className={classes}/>
      <ApostropheSvgLeft style={leftStyles} preserveAspectRatio='none' className={classes}/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ApostropheBackground.js